
import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { ScrollArea } from "@/components/ui/scroll-area";
import { supabase } from "@/integrations/supabase/client";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";

const TermsPopup = () => {
  const [open, setOpen] = useState(false);
  const [terms, setTerms] = useState<{ title: string; content: string } | null>(null);
  const [agreedToTerms, setAgreedToTerms] = useState(false);

  useEffect(() => {
    const checkTermsAccepted = () => {
      const accepted = localStorage.getItem('termsAccepted');
      if (!accepted) {
        setOpen(true);
      }
    };

    const fetchTerms = async () => {
      const { data, error } = await supabase
        .from('terms_policies')
        .select('title, content')
        .eq('category', 'terms')
        .single();

      if (!error && data) {
        setTerms(data);
      }
    };

    fetchTerms();
    checkTermsAccepted();
  }, []);

  const handleAccept = () => {
    if (agreedToTerms) {
      localStorage.setItem('termsAccepted', 'true');
      setOpen(false);
    }
  };

  if (!terms) return null;

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="sm:max-w-[600px]">
        <DialogHeader>
          <DialogTitle>{terms.title}</DialogTitle>
        </DialogHeader>
        <ScrollArea className="h-[400px] mt-4">
          <div className="prose prose-sm max-w-none px-4">
            <div dangerouslySetInnerHTML={{ __html: terms.content.replace(/\n/g, '<br/>') }} />
          </div>
        </ScrollArea>
        <div className="flex items-center space-x-2 mt-4 mb-2">
          <Checkbox 
            id="terms-checkbox" 
            checked={agreedToTerms} 
            onCheckedChange={(checked) => setAgreedToTerms(checked === true)}
          />
          <Label htmlFor="terms-checkbox" className="text-sm">
            By clicking continue you will agree to the terms & conditions
          </Label>
        </div>
        <DialogFooter>
          <Button 
            onClick={handleAccept} 
            className="w-full" 
            disabled={!agreedToTerms}
          >
            I Agree to Terms & Conditions
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default TermsPopup;
